export default __webpack_public_path__ + "static/media/mobilebg.da9aeba6.png";